import {
  Dot,
  Dots, NewsDataWrapper,
  NewsItem,
  NewsItemDate,
  NewsItemTitle,
  Slide,
  SliderWrapper,
  Slides
} from "pages/Main/main.styles";
import React, { useEffect, useRef, useState } from "react";
import { PanInfo, useAnimation } from "framer-motion";
import { INews } from "models/others";

export const SliderNews = ({news}: { news: INews[] }) => {
  const [current, setCurrent] = useState(0);
  const sliderRef = useRef<HTMLDivElement>(null);
  const [width, setWidth] = useState(0);

  const controls = useAnimation();

  // Measure wrapper width
  useEffect(() => {
    const handleResize = () => {
      if (sliderRef.current) {
        setWidth(sliderRef.current.offsetWidth);
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    controls.start({
      x: -current * width + (-current * 16),
      transition: {type: "spring", stiffness: 300, damping: 30},
    });
  }, [current, width, controls]);

  const handleDragEnd = (_: MouseEvent | TouchEvent | PointerEvent, info: PanInfo) => {
    const offset = info.offset.x;
    const threshold = width * 0.25;
    let newIndex = current;

    if (offset < -threshold && current < news.length - 1) {
      newIndex = current + 1;
    } else if (offset > threshold && current > 0) {
      newIndex = current - 1;
    }

    setCurrent(newIndex);
    controls.start({
      x: -newIndex * width + (-newIndex * 16),
      transition: {type: "spring", stiffness: 300, damping: 30},
    });
  };

  return (
    <>
      <SliderWrapper ref={sliderRef}>
        <Slides
          drag="x"
          dragMomentum={false}
          dragElastic={0.2}
          dragConstraints={{
            left: -(news.length - 1) * width,
            right: 0,
          }}
          onDragEnd={handleDragEnd}
          animate={controls}
        >
          {news.map((item) => (
            <Slide key={item.id} style={{width}}>
              <NewsItem>
                <img src={item.image} alt={item.title}/>
                <NewsDataWrapper>
                  <NewsItemTitle>{item.title}</NewsItemTitle>
                  <NewsItemDate>{new Date(item.created_at).toLocaleDateString('ru')}</NewsItemDate>
                </NewsDataWrapper>
              </NewsItem>
            </Slide>
          ))}
        </Slides>
      </SliderWrapper>

      <Dots>
        {news.map((_, idx) => (
          <Dot key={idx} active={idx === current} onClick={() => setCurrent(idx)}/>
        ))}
      </Dots>
    </>
  );
}
